// Bound both render frequency and the wait for partially completed batches.
export const createMapUpdateBatch = (onFlush, size = 8, maxWait = 50) => {
  let pending = []
  let timeout = null
  let cancelled = false

  const flush = () => {
    clearTimeout(timeout)
    timeout = null
    if (cancelled || pending.length === 0) return

    const batch = pending
    pending = []
    onFlush(batch)
  }

  return {
    add: value => {
      if (cancelled) return
      pending.push(value)
      if (pending.length >= size) flush()
      else if (timeout === null) timeout = setTimeout(flush, maxWait)
    },
    flush,
    cancel: () => {
      cancelled = true
      clearTimeout(timeout)
      pending = []
    }
  }
}
